import { combineReducers } from "redux";

import settingsReducer from "./settings.reducer.js";
import themesReducer from "./themes.reducers.js";
import formReducer from "./form.reducer.js";
import loginReducer from "./login.reducer.js";
import profileReducer from "./profile.reducer.js";
import snackbarReducer from "./snackbar.reducer.js";
import signupReducer from "./signup.reducer.js";
import createEventReducer from "./createEvents.reducer.js"
import eventsReducer from "./events.reducer.js";
import usersReducer from "./users.reducer.js"
import leaderboardReducer from "./leaderboard.reducer.js";


export default combineReducers({
  settings: settingsReducer,
  theme: themesReducer,
  form: formReducer,
  login: loginReducer,
  profile: profileReducer,
  snackbar: snackbarReducer,
  signup:signupReducer,
  createEvent: createEventReducer,
  events: eventsReducer,
  users: usersReducer,
  leaderboard: leaderboardReducer,
});
